import { FC, useEffect } from "react";
import { Column, Row } from "../../../../../components/containers";
import { UserUpdatesPopupProps } from "./types";
import { PopupBack, PopupClose } from "../../../../../popup";
import UserProfilePopup from "../user-profile-popup";
import styles from "../styles";
import { AlignItems } from "../../../../../components/containers/types";
import { Text } from "../../../../../components/typography";
import { usePopupStore, useThemeStore } from "../../../../../stores";
import { getDateStr, getTimeStr } from "../../../../../utils";
import { AccessListDiff } from "../access-list";

const UserUpdatesPopup: FC<UserUpdatesPopupProps> = (props) => {
  const { updates } = props;
  const theme = useThemeStore((s) => s.theme);
  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 430,
        background: theme.background,
        height: "100%",
        maxHeight: 605,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Column style={styles.userPopupBase}>
      <PopupClose />
      <PopupBack props={props} Component={UserProfilePopup} />
      <Column style={styles.userPopupContainer} gap={15}>
        {updates.map((update, idx) => (
          <Column
            key={idx}
            style={{
              width: "100%",
              borderBottom: `1px solid ${theme.icon}`,
              paddingBottom: 15,
            }}
            gap={7}
            alignItems={AlignItems.Start}
          >
            <Text
              color={theme.icon}
              size={16}
            >{`به روز شده توسط ${update.by.fullname}`}</Text>
            <Text color={theme.icon} size={16}>{`در تاریخ ${getDateStr(
              update.date
            )} ساعت ${getTimeStr(update.date)}`}</Text>
            {update.access_diff.del.length || update.access_diff.new.length ? (
              <Row style={{ width: "100%" }}>
                <AccessListDiff access_diff={update.access_diff} />
              </Row>
            ) : (
              <></>
            )}
          </Column>
        ))}
      </Column>
    </Column>
  );
};

export default UserUpdatesPopup;
